export default "__VITE_ASSET__DrI1Mg38__"